import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { Company } from "@brand";
import TermsModal from "./TermsModal";
import PrivacyModal from "./PrivacyModal";

const Footer = (): JSX.Element => {
  const copyright = (
    <Typography align={"center"} variant={"subtitle2"} color="text.secondary">
      &copy; {new Date().getFullYear()} {Company.name} &mdash; {Company.city}
    </Typography>
  );

  const links = (
    <Box display="flex" justifyContent="center" alignItems="center">
      <PrivacyModal />
      <TermsModal />
    </Box>
  );

  if (!Company.note) {
    return (
      <Box display={"flex"} justifyContent={"space-between"}>
        {copyright}
        {links}
      </Box>
    );
  }

  return (
    <Box display={"flex"} flexDirection={"column"} gap={"6px"}>
      <Typography align={"center"} variant={"subtitle2"} color="text.secondary">
        {Company.note}
      </Typography>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        {copyright}
        {links}
      </Box>
    </Box>
  );
};

export default Footer;
